<template>
  <div>
    <h3 class='text-center'>ArcGIS OAuth2 Dev Utilities</h3>
    <fieldset>
      <legend>
        <icon name='cog' class='shift-up-2'></icon>
      </legend>
      <div class='row gutters'>
        <div class='col col-6'>
          <div class="form-item">
            <label class='small'>Domain:</label>
            <div class='prepend '>
              <span>https://</span>
              <input v-model='domain' type='text' class='small'>
            </div>
            <div class='desc'>Portal's domain</div>
          </div>
        </div>
        <div class='col col-6'>
          <div class="form-item">
            <label class='small'>Client Id:</label>
            <input v-model='clientId' type='text' class='small'>
            <div class="desc">
              <div class="error">* Required</div>
            </div>
          </div>
        </div>
      </div>
      <div class='row gutters'>
        <div class='col desc'>
          <p class='error'>
            The tokens generated by this app are directly tied to the client id specified above. When this client id
            is destroyed, any tokens generated with it are invalidated. You can use the client id
            <code>
              {{ testClientId }}
            </code>
            for testing, but you should create your own if you plan on doing any serious work. You can generate
            your own client id by creating an application on the
            <a target='_blank' href='https://developers.arcgis.com/'>
              ArcGIS for Developers
            </a>
            site. Be sure to add
            <code>
              {{ redirect_uri }}
            </code>
            as a redirect uri for your application.
          </p>
        </div>
      </div>
    </fieldset>
    <get-access-token :domain='domain' :clientId='clientId'></get-access-token>
    <get-refresh-token :domain='domain' :clientId='clientId'></get-refresh-token>
    <generate-token :domain='domain' :clientId='clientId'></generate-token>
  </div>
</template>

<script>
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/cog';
import GetAccessToken from './GetAccessToken';
import GetRefreshToken from './GetRefreshToken';
import GenerateToken from './GenerateToken';

export default {
  name: 'main',
  components: { Icon, GetAccessToken, GetRefreshToken, GenerateToken },
  props: [],
  data() {
    return {
      domain: 'www.arcgis.com',
      clientId: '',
      testClientId: '1St59aAcmvpPeTYl',
      redirect_uri: '',
    };
  },
  created() {
    this.redirect_uri = `${window.location.origin}${window.location.pathname}`;
  },
  mounted() {},
  methods: {},
};
</script>

<style lang='scss' scoped>
@import '../assets/scss/_variables';

</style>



// WEBPACK FOOTER //
// src/components/Main.vue